import * as tslib_1 from "tslib";
import * as React from 'react';
import cn from 'astro-classname';
import '../icon/index.css';
var Icon = (function (_super) {
    tslib_1.__extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var _a = this.props, type = _a.type, className = _a.className, color = _a.color, style = _a.style, other = tslib_1.__rest(_a, ["type", "className", "color", "style"]);
        var classes = cn('zhuiicon', "zhuiicon-" + type);
        var styles = tslib_1.__assign({}, style, { color: color });
        return React.createElement("i", tslib_1.__assign({ className: classes, style: styles }, other));
    };
    Icon.defaultProps = {
        className: '',
        color: '',
    };
    return Icon;
}(React.Component));
export default Icon;
